module.exports = __webpack_public_path__ + "img/496.d824cb2e.png";